// extracted by mini-css-extract-plugin
export default {"verticalCenter":"PBlmE1Y6aiELt1iBCUJ1"};